import Container from '@/components/Container';
import HeadingOne from '@/components/Heading/HeadingOne';
import PageHead from '@/components/PageHead';
import PageLayout from '@/components/layout/page-layout';
import { useState } from 'react';
import NextLink from 'next/link';
import Modal from '@/components/ModalDocuments';
import Portal from '@/components/Portal';

export default function Page() {
	const [isOpenModalEstatuto, setIsOpenModalEstatuto] = useState(false);
	const [isOpenModalRelatorioAtividades, setIsOpenRelatorioAtividades] =
		useState(false);

	return (
		<>
			<PageHead
				page={{
					title: 'Instituto Deixe Vivo - Transparência',
					keywords:
						'OSC, Instituto, Deixe Vivo, Doação de órgãos e tecidos, transplantes, renal, tecidos, transparência',
					colorScheme: 'light dark',
					description: 'Instituto Deixe Vivo',
					robots: 'nofollow, noindex',
				}}
				og={{
					description: 'Instituto Deixe Vivo - Transparência',
					site_name: 'Instituto Deixe Vivo - Transparência',
					title: 'Instituto Deixe Vivo - Transparência',
					type: 'website',
					url: 'https://deixevivo.org.br',
					image: {
						alt: 'Logo do Instituto, ao lado esquerdo da imagem um rosto feliz e ao lado direito texto que diz Instituto Deixe Vivo',
						fbAdmins: 'instituto.deixevivo',
						src: 'https://res.cloudinary.com/oliveiradev/image/upload/v1681919729/InstitutoDeixeVivo/logos/logo-deixe-vivo-1200x1200.jpg',
						type: 'image/jpg',
						width: '1200',
						height: '1200',
					},
				}}
				twitter={{
					card: 'summary',
					description: 'Instituto Deixe Vivo - Quem faz acontecer',
					site: 'Instituto Deixe Vivo - Quem faz acontecer',
					title: 'Instituto Deixe Vivo - Quem faz acontecer',
					url: 'https://deixevivo.org.br',
					image: {
						alt: 'Logo do Instituto, ao lado esquerdo da imagem um rosto feliz e ao lado direito texto que diz Instituto Deixe Vivo',
						src: 'https://res.cloudinary.com/oliveiradev/image/upload/v1681919729/InstitutoDeixeVivo/logos/logo-deixe-vivo-1200x1200.jpg',
					},
				}}
			/>

			<PageLayout>
				<Container className="py-8">
					<HeadingOne horizontalRow>Transparência</HeadingOne>
					<div className="my-4">
						<section>
							<h2>
								<NextLink
									href="#"
									onClick={(_) => setIsOpenModalEstatuto(true)}
									className="underline text-blue-500"
								>
									Estatuto Social
								</NextLink>
							</h2>
							{isOpenModalEstatuto && (
								<Portal>
									<Modal
										title="Estatuto Social"
										isOpen={isOpenModalEstatuto}
										setIsOpen={setIsOpenModalEstatuto}
										src="/assets/docs/Associação_Deixe_Vivo_-_Estatuto_registrado.pdf"
									/>
								</Portal>
							)}
						</section>
						<section className="mt-2">
							<h2>
								<NextLink
									href="#"
									onClick={(_) => setIsOpenRelatorioAtividades(true)}
									className="underline text-blue-500"
								>
									Relatório de Atividades (2022)
								</NextLink>
							</h2>
							{isOpenModalRelatorioAtividades && (
								<Portal>
									<Modal
										title="Relatório de Atividades (2022)"
										isOpen={isOpenModalRelatorioAtividades}
										setIsOpen={setIsOpenRelatorioAtividades}
										src="/assets/docs/relatorio-de-atividades-de-2022.pdf"
									/>
								</Portal>
							)}
						</section>
					</div>
				</Container>
			</PageLayout>
		</>
	);
}
